'use client';

import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';

type TGithubContext = {
  showNewForm: boolean;
  editId: string;
  deleteId: string;
  toggleShowNewForm: () => void;
  setEditId: Dispatch<SetStateAction<string>>;
  setDeleteId: Dispatch<SetStateAction<string>>;
};

const initialState = {
  showNewForm: false,
  editId: '',
  deleteId: '',
  toggleShowNewForm: () => {},
  setEditId: () => {},
  setDeleteId: () => {}
};

const GithubContext = createContext<TGithubContext>(initialState);

const useGithubContext = (): TGithubContext => useContext(GithubContext);

const GithubProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const [showNewForm, setShowNewForm] = useState<boolean>(initialState.showNewForm);
  const [editId, setEditId] = useState<string>(initialState.editId);
  const [deleteId, setDeleteId] = useState<string>(initialState.deleteId);

  const toggleShowNewForm = () => setShowNewForm((oldState) => !oldState);

  return (
    <GithubContext.Provider
      value={{
        showNewForm,
        toggleShowNewForm,
        editId,
        setEditId,
        deleteId,
        setDeleteId
      }}
    >
      {children}
    </GithubContext.Provider>
  );
};

export { GithubProvider, useGithubContext };
